import {getCheckoutClient} from '../config/CheckoutClient';
import {fetchReservation, deleteReservation} from './reservation';
import { setPriceLevelsQuantities} from '../views/ticket-picker/actions/ticket-picker';
import { setLoading } from 'checkout/actions/loading';
import { addServerErrors, addAlert } from './ui';
import { isReservationEmpty } from 'checkout/selectors/reservation';
import { submitInsurance } from 'checkout/views/insurance/actions/insurance';
import { updateDonations } from '../views/donations/actions/donations';

export function setTickets(tickets) {
    return {type: "SET_TICKETS", tickets}
}

export function fetchTickets(token, secret) {
    return (dispatch, getState) => {
        let state = getState();
        return getCheckoutClient(state.ui.apiUrl).reservationGetRequest(token, 'tickets', secret).then((result) => {
            let filteredTickets = result.body.data.filter((item) => item.attributes.hasBundleSaleId === false);
            dispatch(setTickets(filteredTickets));
            let tickets = getSoldOrHeldTickets(filteredTickets);

            // updated quantities
            let priceLevelsQuantities = buildPriceLevelsQuantities(state.priceLevel.levels, tickets);
            dispatch(setPriceLevelsQuantities(priceLevelsQuantities));
        });
    }
}

export function updateTicketQuantities(quantities, token, secret, reFetch = true, reSubmitDonations) {
    return (dispatch, getState) => {
        let state = getState();
        let plId = quantities.tickets[0].pricing_level_id;
        dispatch(setLoading("TICKET_QUANTITY_"+plId+"_REQUEST"));

        return getCheckoutClient(state.ui.apiUrl).reservationUpdateRequest(token, 'tickets', quantities, secret).then((result) => {
            let insuranceReq = null;
            if(state.insurance.provider !== "" && state.insurance.selected !== "") {
                insuranceReq = true;
            }

            if(reFetch) {

                const doRefetch = () => {
                    if (insuranceReq) {
                        return dispatch(submitInsurance()).then(()  => {
                            Promise.all([
                                dispatch(fetchReservation(token, secret)),
                                dispatch(fetchTickets(token, secret)),
                            ]).then(() => {
                                dispatch(setLoading("TICKET_QUANTITY_" + plId + "_SUCCESS"));
                                if (isReservationEmpty(getState())) {
                                    dispatch(deleteReservation());
                                }
                            }).catch((e) => {
                                dispatch(setLoading("TICKET_QUANTITY_" + plId + "_FAILURE"));
                            });
                        });
                    } else {
                        return Promise.all([
                            dispatch(fetchReservation(token, secret)),
                            dispatch(fetchTickets(token, secret)),
                        ]).then(() => {
                            dispatch(setLoading("TICKET_QUANTITY_" + plId + "_SUCCESS"));
                            if (isReservationEmpty(getState())) {
                                dispatch(deleteReservation());
                            }
                        }).catch((e) => {
                            dispatch(setLoading("TICKET_QUANTITY_" + plId + "_FAILURE"));
                        });
                    }
                }

                //if updating donations, needs to happen before refetching so that
                //the reservation data reflects the updated donation amount(s)
                if (reSubmitDonations) {
                    dispatch(updateDonations()).catch(e => {
                        //do nothing. At this point the event may have been removed from the reservation
                        //as a result of removing tickets which will cause the donation request to 400.
                        //Any actual errors will be reflected in the reservation when it is refetched.
                    }).finally(() => {
                        doRefetch()
                    });
                } else {
                    doRefetch();
                }

            } else {
                dispatch(setLoading("TICKET_QUANTITY_"+plId+"_SUCCESS"));
                return dispatch(fetchTickets(token, secret));
            }
        }).catch((e) => {
            dispatch(setLoading("TICKET_QUANTITY_"+plId+"_FAILURE"));
            if(e.response && e.response.body) {
                dispatch(addServerErrors(e.response.body.errors));
            } else {
                dispatch(addAlert(e));
            }
            return Promise.reject("");
        });
    }
}

function buildPriceLevelsQuantities(priceLevels, tickets) {
    let quantityArrays = {};
    Object.keys(priceLevels).map(priceLevelId => {
        let level = priceLevels[priceLevelId];
        quantityArrays[priceLevelId] = buildQuantityArray(level.minimum_purchase_limit, level.transaction_limit, level.increment_by);
    });

    Object.keys(quantityArrays).map(priceLevelId => {
        if (tickets[priceLevelId]) {
            quantityArrays[priceLevelId].length = Math.abs(quantityArrays[priceLevelId].length - tickets[priceLevelId]);
        }
    });

    return quantityArrays;
}

function buildQuantityArray(min = 0, max = 10, step = 1) {
    min = min === 0 ? 1 : min;
    let quantities = [];

    for(var i = min; i <= max; i += step) {
        quantities.push(i);
    }

    return quantities;
}

function getSoldOrHeldTickets(tickets) {
    let counts = {};
    for (let i = 0; i < tickets.length; i++) {
        if (counts[tickets[i].attributes.price_level_id] === undefined) {
            counts[tickets[i].attributes.price_level_id] = 1;
        } else {
            counts[tickets[i].attributes.price_level_id] += 1;
        }
    }

    return counts;
}
